export enum StorageKeys {
  TOKEN = 'token',
  REFRESH_TOKEN = 'refreshToken',
  DEVICE_ID = 'deviceId',
}
